const state = {
  user: null,
  token: '',
  siteInfo: {}
};

export default state;



// WEBPACK FOOTER //
// ./src/store/state.js